/* ============================================================================
   SVNTY — THE FILTER PAGE + THE SORT MENU (R192, 2026-09-25, dev1.1; D6-1 refuter F's fixes). Deferred, no dependencies.

   Trade's facets.js keeps every mechanism (the fetch, the re-render by id, the counts, the applied chips, the
   drawer's lock through MenuDrawer). This script adds SVNTY's face on top:
     1. ACCORDIONS: MenuDrawer binds a drill-down to every <summary> inside the drawer; a document-capture
        listener runs first, stops it for the group summaries and toggles the group itself (several may be open).
        The open set is remembered across a close (MenuDrawer folds every nested details on close: F-07).
     2. SHOW N PIECES mirrors Trade's live count (.mobile-facets__count, refreshed after every change), pluralised (F-32).
     3. PRICE PRESETS write Trade's two fields and let the form submit; handled in capture so MenuDrawer's close binding
        on every <button> never folds the group (F-06); the pressed state compares numbers (F-19).
     4. VALUE LINES: after every render and every input, each group's summary line is rebuilt from the DOM (the fired
        group's summary is never re-rendered by facets.js: F-04); the price line uses the one wording (F-05).
     5. GROUP ORDER: after every render the groups are re-sorted by the store's order (facets.js puts a returning
        group at the top: F-08).
     6. ONE CLOSE PATH: the X, SHOW, Escape, the desktop dim and the proxy all close through closeSheet(), never through
        MenuDrawer's button binding (F-15, F-16, F-17); the sheet is modal: everything else is inert while open (F-18).
     7. THE DESKTOP PANEL: from 990 px the sheet is a panel under the header; Trade's body lock (overflow-hidden-mobile,
        which the headstack reads as a door) is swapped for html.svnty-fs-lock so the header stays whole (D4-32's rule).
     8. THE SORT MENU: the chip opens the sheet; a row writes the hidden <select> and fires `input`, which facets.js
        already listens for; the chip's value follows; Escape, the scrim and an outside click close (the outside click
        never reaches the page: F-23); focus returns to the chip's select (F-21); the phone takes Trade's one lock (F-24).
     9. THE COUNTED GLYPHS (D6-9, R201): the bar's FILTER and SORT glyphs are bound counted icons (snippets/svnty-counted-icon.liquid
        kinds filter and sort); this script writes their truth. FILTER: the proxy is no .mobile-facets__open (facets.js rewrites
        the FIRST one's innerHTML after every change, which would tear the icon down mid-animation), so Trade refreshes the
        drawer's own opener; its badge is watched and its count written onto the proxy icon's data-svnty-count, with the
        screen reader's "N filters applied". SORT: 1 when the chip's select differs from the results' default, else 0.
   Nothing here writes to a sticky layer from a scroll handler. No console, ASCII only.
   ============================================================================ */
(function () {
  'use strict';
  var root = document.documentElement;
  var DESK = window.matchMedia('(min-width: 990px)');
  var proxy = null, drawer = null, disc = null, summary = null, form = null;
  var openKeys = null;
  var inerted = [];

  function groups() { return Array.prototype.slice.call(document.querySelectorAll('#FacetsWrapperMobile > details.js-filter')); }
  function keyOf(d) { return d.getAttribute('data-svnty-group') || d.id; }
  function isOpen() { return !!(disc && disc.hasAttribute('open')); }
  function focusQuiet(el) { if (!el || !el.focus) return; try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); } }

  /* ---------------------------------------------------------------- the modal: everything else inert while a sheet is open (F-18)
     The sheet hangs inside the header (THE STATUS BAR law), so every sibling on the path from the sheet up to <body> goes inert */
  function modal(sheet, on) {
    inerted.forEach(function (el) { el.inert = false; });
    inerted = [];
    if (!on || !('inert' in HTMLElement.prototype)) return;
    var node = sheet;
    while (node && node !== document.body && node.parentNode) {
      var parent = node.parentNode;
      Array.prototype.forEach.call(parent.children, function (el) {
        if (el === node || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
        if (!el.inert) { el.inert = true; inerted.push(el); }
      });
      node = parent;
    }
  }

  /* THE DOOR'S HOST (THE STATUS BAR law, D4-6's rule): every door hangs from the header inside the slab as an ABSOLUTE box;
     a fixed layer over the slab lets iOS paint the announcement bar's black through the status strip (the iPhone,
     2026-09-25 18:46) and leaves the page under Safari's bottom bar */
  function host() { return document.querySelector('.header-wrapper .header') || document.querySelector('.header-wrapper') || document.body; }

  /* ---------------------------------------------------------------- 0. out of the sticky bar: the sheet lives in <body>
     The results bar is position: sticky, a stacking context of its own, so a fixed sheet inside it paints under the header and
     under the door's curtain. At boot the drawer and the sort sheet move to <body>; the bar keeps a proxy FILTER button that
     opens the real (visually hidden) summary. Trade's MenuDrawer and facets.js find everything by id and class, wherever it is. */
  function hoist() {
    proxy = document.querySelector('[data-svnty-fs-proxy]');
    drawer = document.querySelector('[data-svnty-fs-drawer]');
    var h = host();
    if (drawer && drawer.parentNode !== h) { h.appendChild(drawer); drawer.classList.add('svnty-door'); }
    /* THE RISE (D6-6) is a popover fixed under the SORT chip, no scrim, no lock: it lives in <body>, out of the sticky
       bar's stacking context, so it paints above the grid (D6-15, refuter G-21: this said "bottom sheet", stale since D6-6) */
    var ss = document.querySelector('[data-svnty-sort]');
    if (ss && ss.parentNode !== document.body) document.body.appendChild(ss);
    if (!proxy || !drawer) return;
    disc = drawer.querySelector('[data-svnty-fs]');
    summary = disc && disc.querySelector('summary');
    form = document.getElementById('FacetFiltersFormMobile');
    if (!summary) return;
    proxy.addEventListener('click', function (e) { if (isOpen()) closeSheet(e); else summary.click(); });
    var was = isOpen();
    var onToggle = function () {
      var open = isOpen();
      proxy.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open === was) return;
      was = open;
      /* D6-15 (refuter G-10): MenuDrawer's trapFocus leaves focus on the visually hidden summary, outside the dialog; the
         dialog itself takes it (a frame later, after MenuDrawer's own focus), so VoiceOver enters and Tab starts inside */
      if (open) { restoreGroups(); colourGroup(); modal(drawer, true); requestAnimationFrame(function () { if (isOpen()) focusQuiet(drawer.querySelector('.svnty-fs__inner')); }); }
      else { modal(drawer, false); setTimeout(function () { focusQuiet(proxy); }, 0); }
    };
    disc.addEventListener('toggle', onToggle);
    if (typeof MutationObserver === 'function') new MutationObserver(onToggle).observe(disc, { attributes: true, attributeFilter: ['open'] });
  }

  /* one close path (F-15): MenuDrawer's own close (the lock, the trap, the animation) with no focus of its own; the proxy takes focus quietly */
  function closeSheet(e) {
    if (!isOpen()) return;
    if (drawer && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(e || new CustomEvent('svnty:close'), null);
    else summary.click();
    focusQuiet(proxy);
  }

  /* ---------------------------------------------------------------- 1. accordions, with memory (F-07) */
  function seedGroups() {
    if (!openKeys) openKeys = new Set();
    groups().forEach(function (d) { if (d.hasAttribute('open')) openKeys.add(keyOf(d)); });
  }
  function restoreGroups() {
    if (!openKeys) return;
    groups().forEach(function (d) {
      var open = openKeys.has(keyOf(d));
      if (open !== d.hasAttribute('open')) { if (open) d.setAttribute('open', ''); else d.removeAttribute('open'); }
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var sum = e.target.closest && e.target.closest('.svnty-fs details.js-filter > summary');
    if (!sum) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var d = sum.parentNode, open = !d.hasAttribute('open');
    if (open) d.setAttribute('open', ''); else d.removeAttribute('open');
    sum.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (openKeys) { if (open) openKeys.add(keyOf(d)); else openKeys.delete(keyOf(d)); }
  }, true);

  /* ---------------------------------------------------------------- 2. the count on the button (F-32, F-38) */
  function mirrorCount() {
    var count = document.querySelector('.svnty-fs .mobile-facets__count');
    var btn = document.querySelector('[data-svnty-fs-show]');
    if (!count || !btn) return;
    var one = btn.getAttribute('data-svnty-show-one') || '', other = btn.getAttribute('data-svnty-show-other') || '';
    var sync = function () {
      /* S-21 (lane SHEET_S, 2026-09-26): ONE COUNT SOURCE. With THE COLOUR ADDRESS set, the button reads the narrowed
         count svnty-collection.js writes (the bar's, the results head's and this sheet's count read the same), and while the
         narrowing is still loading its pages the button keeps what it said (never Shopify's unnarrowed number in between) */
      var cs = window.SVNTY && window.SVNTY.colourState, n;
      if (colourEntries().length && cs) {
        if (cs.pending || typeof cs.n !== 'number') return;
        n = cs.n;
      } else {
        var m = (count.textContent || '').replace(/,/g, '').match(/\d+/);
        if (!m) return;
        n = parseInt(m[0], 10);
      }
      var t = n === 1 && one ? one : other.replace('[n]', String(n));
      if (t && btn.textContent !== t) btn.textContent = t;
    };
    sync();
    mirrorSoon = sync;
    if (count.__svntyObs) return;
    count.__svntyObs = true;
    if (typeof MutationObserver === 'function') new MutationObserver(sync).observe(count, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------- 2b. THE COUNTED GLYPH on FILTER (D6-9): the opener is the truth */
  function filterCount() {
    if (!proxy || !drawer) return;
    var opener = drawer.querySelector('summary .mobile-facets__open');
    var icon = proxy.querySelector('svnty-counted-icon[data-kind="filter"]');
    var said = proxy.querySelector('[data-svnty-fs-applied]');
    if (!opener || !icon) return;
    var write = function () {
      var badge = opener.querySelector('.svnty-fs__badge');
      var n = badge ? parseInt((badge.textContent || '').replace(/\D/g, ''), 10) || 0 : 0;
      n += colourEntries().length;   /* D8-7: a colour of THE COLOUR ADDRESS is an applied filter (the badge equals its chips) */
      if (icon.getAttribute('data-svnty-count') !== String(n)) icon.setAttribute('data-svnty-count', String(n));
      if (said) {
        var t = n ? (n === 1 ? said.getAttribute('data-one') || '' : (said.getAttribute('data-other') || '').replace('[n]', String(n))) : '';
        if (said.textContent !== t) said.textContent = t;
      }
    };
    /* Trade rewrites the opener in the same task as the product grid; the grid's first frame is the heavy one (its layout
       and paint), so the count lands two frames later and the glyph's motion plays on clean frames, whole */
    var queued = false;
    var sync = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { requestAnimationFrame(function () { queued = false; write(); }); });
    };
    filterCountSoon = sync;
    write();
    if (opener.__svntyObs || typeof MutationObserver !== 'function') return;
    opener.__svntyObs = true;
    new MutationObserver(sync).observe(opener, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------- 3. price presets (F-06, F-19) */
  function num(v) { v = String(v == null ? '' : v).replace(/,/g, '').trim(); if (v === '') return ''; var f = parseFloat(v); return isFinite(f) ? String(f) : ''; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.svnty-fs [data-svnty-fs-preset]');
    if (!b) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var body = b.closest('.svnty-fs__body');
    if (!body) return;
    var min = body.querySelector('input[name$=".gte"]'), max = body.querySelector('input[name$=".lte"]');
    if (!min || !max) return;
    var on = b.getAttribute('aria-pressed') === 'true';
    Array.prototype.forEach.call(body.querySelectorAll('[data-svnty-fs-preset]'), function (x) { x.setAttribute('aria-pressed', 'false'); });
    if (on) { min.value = ''; max.value = ''; }
    else { min.value = b.getAttribute('data-min') || ''; max.value = b.getAttribute('data-max') || ''; b.setAttribute('aria-pressed', 'true'); }
    valueLines();
    max.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
  function markPreset() {
    Array.prototype.forEach.call(document.querySelectorAll('.svnty-fs__body'), function (body) {
      var min = body.querySelector('input[name$=".gte"]'), max = body.querySelector('input[name$=".lte"]');
      if (!min || !max) return;
      var a = num(min.value), z = num(max.value);
      Array.prototype.forEach.call(body.querySelectorAll('[data-svnty-fs-preset]'), function (b) {
        var hit = (a || z) && num(b.getAttribute('data-min')) === a && num(b.getAttribute('data-max')) === z;
        b.setAttribute('aria-pressed', hit ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------- 4. the value lines (F-04, F-05): the one wording, from the DOM */
  function money(body, n) {
    var f = body.getAttribute('data-svnty-money') || 'EGP 1';
    var v = Number(n);
    return f.replace('1', isFinite(v) ? v.toLocaleString('en-US', { maximumFractionDigits: 2 }) : String(n));
  }
  function priceLabel(body, a, b) {
    if (a === '' && b === '') return '';
    if (a === '' || parseFloat(a) === 0) return b === '' ? '' : (body.getAttribute('data-svnty-under') || 'Under [a]').replace('[a]', money(body, b));
    if (b === '') return (body.getAttribute('data-svnty-over') || 'Over [a]').replace('[a]', money(body, a));
    return money(body, a) + ' ' + (body.getAttribute('data-svnty-to') || 'to') + ' ' + money(body, b);
  }
  function valueLines() {
    groups().forEach(function (d) {
      var v = d.querySelector('.svnty-fs__sum-value'), body = d.querySelector('.svnty-fs__body');
      if (!v || !body) return;
      var text;
      if (body.hasAttribute('data-svnty-money')) {
        var min = body.querySelector('input[name$=".gte"]'), max = body.querySelector('input[name$=".lte"]');
        text = priceLabel(body, min ? num(min.value) : '', max ? num(max.value) : '');
      } else {
        var labels = [];
        Array.prototype.forEach.call(body.querySelectorAll('input.svnty-fs__check:checked'), function (i) { labels.push(i.getAttribute('data-svnty-label') || i.value); });
        /* D8-7: the Color group's rows are buttons on THE COLOR MAP; a pressed one names itself */
        Array.prototype.forEach.call(body.querySelectorAll('button[data-svnty-colour][aria-pressed="true"]'), function (b) { labels.push(b.getAttribute('data-svnty-name') || ''); });
        text = labels.join(', ');
      }
      if (v.textContent !== text) v.textContent = text;
    });
  }

  /* ---------------------------------------------------------------- D8-7 THE COLOR MAP IN THE SHEET (R237, 04:06)
     The Color group lists the colours of the page's pieces as their TRUE SWATCH (S-20 below: the page's own map, one markup
     with the search sheet's, snippets/svnty-colour-map), one row per (name, kind) with the stripe drawn and the count. A row is a button: it toggles its key in THE COLOUR
     ADDRESS (a hidden svnty_c field in this form: facets.js writes the URL from the form's fields, so the address rides every
     re-render) and fires the form's input event so facets.js renders the page; svnty-collection.js narrows the grid to the
     pieces carrying that swatch and counts them live. The taxonomy's family checkboxes leave the group (the map supersedes
     them); a family still in the address from an old link keeps its applied chip and its remove. */
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function colourEntries() {
    var f = form && form.querySelector('input[name="svnty_c"]');
    var raw = f ? f.value : (new URLSearchParams(window.location.search).get('svnty_c') || '');
    return raw.split('|').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function writeColour(list) {
    if (!form) return;
    var f = form.querySelector('input[name="svnty_c"]');
    if (list.length) {
      if (!f) { f = document.createElement('input'); f.type = 'hidden'; f.name = 'svnty_c'; form.appendChild(f); }
      f.value = list.join('|');
      f.dispatchEvent(new Event('input', { bubbles: true }));
    } else if (f) {
      f.parentNode.removeChild(f);
      var any = form.querySelector('input, select');
      if (any) any.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
  function markColour(list) {
    var on = colourEntries().map(function (x) { return x.toLowerCase(); });
    Array.prototype.forEach.call(list.querySelectorAll('button[data-svnty-colour]'), function (b) {
      var k = (b.getAttribute('data-svnty-colour') || '').toLowerCase(), sel = on.indexOf(k) >= 0 || on.indexOf(k.split(':')[0]) >= 0;
      if (b.getAttribute('aria-pressed') !== String(sel)) b.setAttribute('aria-pressed', sel ? 'true' : 'false');
      b.classList.toggle('active', sel);
    });
  }
  /* S-20 (lane SHEET_S, 2026-09-26): THE PAGE'S COLOR MAP. The group lists the colours of THIS page's pieces (the
     collection's or the search result's, under the filters applied), each with the count of those pieces, from
     sections/svnty-colour-scope.liquid fetched from the page's own address (less page, sort and svnty_c) on the filter door's
     first touch and after every filter change; the whole catalogue's map stays the search sheet's. A color no piece here
     carries never shows (an applied one keeps its chip in the applied row). Until the page's map is in, the list shows
     nothing rather than another page's colours. */
  var scope = { url: '', el: null, p: null };
  function scopeUrl() {
    var u = new URL(window.location.href);
    ['page', 'svnty_c', 'sort_by', 'section_id'].forEach(function (k) { u.searchParams.delete(k); });
    u.searchParams.set('section_id', 'svnty-colour-scope');
    return u.pathname + '?' + u.searchParams.toString();
  }
  function loadScope() {
    if (!document.querySelector('#FacetsWrapperMobile details[data-svnty-group="color"]') || typeof fetch !== 'function') return null;
    var url = scopeUrl();
    if (scope.url === url && scope.p) return scope.p;
    scope.url = url;
    var mine = scope.p = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { return t ? new DOMParser().parseFromString(t, 'text/html').querySelector('[data-svnty-colour-scope]') : null; })
      .catch(function () { return null; })
      .then(function (el) {
        if (scope.p !== mine) return null;
        if (el) { scope.el = el; scope.key = url; } else if (!scope.el) scope.failed = true;
        /* P17-19 (the eye pass's P3-9, THE iOS TAP LAW): the door's first press only fetches; the list is written when the sheet
           is open (here, or by the open itself), never into the closed sheet between a press and its click */
        if (isOpen()) colourGroup();
        return el;
      });
    return mine;
  }
  function colourGroup() {
    var group = document.querySelector('#FacetsWrapperMobile details[data-svnty-group="color"]');
    if (!group) return;
    var list = group.querySelector('ul.svnty-fs__list');
    if (!list) return;
    var src = scope.el;
    if (!src) { list.classList.toggle('svnty-fs__list--waiting', !scope.failed && !list.hasAttribute('data-svnty-map')); return; }
    var stamp = scope.key + '#' + src.childElementCount;
    if (list.getAttribute('data-svnty-map') === stamp) { markColour(list); valueLines(); return; }
    var chips = Array.prototype.slice.call(src.querySelectorAll('a.svnty-chip--dot'));
    var html = '';
    chips.forEach(function (a) {
      var key = a.getAttribute('data-svnty-colour') || '', name = (a.textContent || '').replace(/\s+/g, ' ').trim();
      var dot = a.querySelector('.svnty-chip__dot'), n = ((a.getAttribute('aria-label') || '').match(/(\d+) piece/) || [])[1] || '';
      if (n === '0') return;
      html += '<li class="mobile-facets__item list-menu__item svnty-fs__item"><button type="button" class="facets__label mobile-facets__label svnty-fs__label svnty-fs__label--sw" data-svnty-colour="' + esc(key) + '" data-svnty-name="' + esc(name) + '" aria-pressed="false">' +
        (dot ? dot.outerHTML : '<span class="svnty-chip__dot" aria-hidden="true"></span>') +
        '<span class="facet-checkbox__text svnty-fs__text" aria-hidden="true"><span class="facet-checkbox__text-label">' + esc(name) + '</span></span>' +
        '<span class="svnty-fs__n" aria-hidden="true">' + esc(n) + '</span><span class="visually-hidden">' + esc(name) + (n ? ' (' + esc(n) + ')' : '') + '</span></button></li>';
    });
    list.innerHTML = html;
    list.classList.add('svnty-fs__list--map');
    list.classList.remove('svnty-fs__list--waiting');
    list.setAttribute('data-svnty-map', stamp);
    markColour(list);
    valueLines();
  }
  function colourTaps() {
    if (!form) return;
    form.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[data-svnty-colour]');
      if (!b) return;
      e.preventDefault();
      var key = b.getAttribute('data-svnty-colour') || '', list = colourEntries(), low = key.toLowerCase();
      var i = list.map(function (x) { return x.toLowerCase(); }).indexOf(low);
      /* an old link's bare name (either kind) is pressed on both of its rows: a tap on one takes the bare name out */
      var bare = low.split(':')[0], j = list.map(function (x) { return x.toLowerCase(); }).indexOf(bare);
      if (i >= 0) list.splice(i, 1); else if (j >= 0) list.splice(j, 1); else list.push(key);
      b.setAttribute('aria-pressed', i >= 0 || j >= 0 ? 'false' : 'true');
      writeColour(list);
      valueLines();
      filterCountSoon();
    });
    /* the first touch (or key, or hover on a mouse) of the filter door fetches the page's map, so it is in when the sheet opens */
    if (proxy) ['pointerdown', 'pointerenter', 'focus'].forEach(function (t) { proxy.addEventListener(t, loadScope, { passive: true }); });
    document.addEventListener('svnty:colour:count', function () { mirrorSoon(); });
  }
  var mirrorSoon = function () {};
  var filterCountSoon = function () {};

  /* ---------------------------------------------------------------- 5. the store's order after every render (F-08) */
  function order() {
    var wrap = document.getElementById('FacetsWrapperMobile');
    if (!wrap) return;
    var ds = groups();
    if (ds.length < 2) return;
    var idx = function (d) { var m = (d.getAttribute('data-index') || '').match(/\d+/); return m ? parseInt(m[0], 10) : 999; };
    var sorted = ds.slice().sort(function (a, b) { return idx(a) - idx(b); });
    if (sorted.every(function (d, i) { return d === ds[i]; })) return;
    var mark = document.createComment('svnty order');
    wrap.insertBefore(mark, ds[0]);
    sorted.forEach(function (d) { wrap.insertBefore(d, mark); });
    wrap.removeChild(mark);
  }

  /* ---------------------------------------------------------------- 6. the desktop panel's own lock */
  function panelLock() {
    if (!disc) return;
    var sbw = 0;
    function swap() {
      var open = isOpen();
      if (!DESK.matches) { root.classList.remove('svnty-fs-lock'); root.style.removeProperty('--svnty-fs-sbw'); if (form) { form.style.removeProperty('top'); form.style.removeProperty('height'); } return; }
      if (form) {
        /* the layer is an absolute box in the header's slab: its top is the slab's bottom, read against the layer's own
           containing block (set top 0, measure, then place), its height runs to the large viewport's bottom */
        var slab = document.querySelector('.svnty-headstack');
        var sr = slab ? slab.getBoundingClientRect() : null;
        form.style.top = '0px';
        var cbTop = form.getBoundingClientRect().top;
        /* P20 THE SEAT: the layer hangs from the header's own bottom, the bar shown or parked (the slab's box keeps the parked
           bar's height, which left a strip of undimmed page under the header). Every read here is a DIFFERENCE inside the
           slab: while the page is locked for the open the slab's rect is read scrolled away with the page, and a height taken
           from its absolute bottom ran the foot out of the window */
        var bar = form.closest ? form.closest('.header-wrapper') : null;
        var seat = bar ? bar.getBoundingClientRect().bottom : (sr ? sr.bottom : 0);
        form.style.top = Math.round(seat - cbTop) + 'px';
        form.style.height = 'calc(100lvh - ' + Math.round(seat - (sr ? sr.top : 0)) + 'px)';
        /* D11-5 (image 4: the foot cut): the box measures itself once it stands */
        requestAnimationFrame(fit);
      }
      if (open) {
        sbw = window.innerWidth - root.clientWidth;
        root.style.setProperty('--svnty-fs-sbw', sbw + 'px');
        root.classList.add('svnty-fs-lock');
        /* Trade locks the body for the phone drawer; at desktop the header stays whole, so the headstack must not read a door */
        setTimeout(function () { document.body.classList.remove('overflow-hidden-mobile'); }, 0);
      } else {
        root.classList.remove('svnty-fs-lock');
        root.style.removeProperty('--svnty-fs-sbw');
      }
    }
    /* P20 THE FIT: the layer ends on the window's bottom, whatever the header did since the seat was read (a filter's answer
       moves the page and the bar comes back: the layer follows the header down and its foot was cut by the bar's height) */
    function fit() {
      if (!form || !DESK.matches || !isOpen()) return;
      var r = form.getBoundingClientRect();
      if (r.top < 0) return;
      var over = r.bottom - window.innerHeight;
      if (Math.abs(over) > 0.5) form.style.height = Math.round(r.height - over) + 'px';
    }
    function refit() { if (!DESK.matches || !isOpen()) return; requestAnimationFrame(fit); setTimeout(fit, 260); setTimeout(fit, 520); }
    window.addEventListener('scroll', refit, { passive: true });
    if (typeof MutationObserver === 'function') new MutationObserver(refit).observe(root, { attributes: true, attributeFilter: ['class'] });
    disc.addEventListener('toggle', swap);
    if (typeof MutationObserver === 'function') new MutationObserver(swap).observe(disc, { attributes: true, attributeFilter: ['open'] });
    DESK.addEventListener('change', swap);
    window.addEventListener('resize', function () { if (isOpen()) swap(); }, { passive: true });
    swap();
  }

  /* ---------------------------------------------------------------- 7. the closes: X and SHOW (F-15), Escape (F-17), the desktop dim (F-16) */
  document.addEventListener('click', function (e) {
    if (!isOpen() || !e.target.closest) return;
    if (e.target.closest('.svnty-fs [data-svnty-fs-close], .svnty-fs [data-svnty-fs-show]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      closeSheet(e);
      return;
    }
    if (!DESK.matches) return;
    if (drawer.contains(e.target)) { if (e.target === form) closeSheet(e); return; }
    closeSheet(e);                                        /* the inert page beside the panel */
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' && String(e.code || '').toUpperCase() !== 'ESCAPE') return;
    if (!isOpen()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    closeSheet(e);
  }, true);

  /* ---------------------------------------------------------------- 8. the sort menu: THE RISE under the chip (D6-6) */
  function sortMenu() {
    var chip = document.querySelector('[data-svnty-sort-chip]');
    var sheet = document.querySelector('[data-svnty-sort]');
    if (!chip || !sheet) return;
    var select = chip.querySelector('select');
    var sform = chip.querySelector('form');
    var value = chip.querySelector('.svnty-sort-chip__value');
    var panel = sheet.querySelector('.svnty-ss__panel');
    var icon = chip.querySelector('svnty-counted-icon[data-kind="sort"]');
    var def = chip.getAttribute('data-svnty-sort-default') || '';
    var lastFocus = null;
    /* D6-9: the glyph hosts 1 while a sort other than the results' default is applied; the select is the truth */
    function sortCount() {
      if (!icon) return;
      var n = def && select.value && select.value !== def ? '1' : '0';
      if (icon.getAttribute('data-svnty-count') !== n) icon.setAttribute('data-svnty-count', n);
    }
    if (!select || !sform || !panel) return;
    sform.setAttribute('data-svnty-sort-face', 'on');
    var COARSE = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    if (COARSE) sform.tabIndex = -1;                                 /* D8-14: the box can take the focus back on a touch device */
    function isOpenMenu() { return sheet.classList.contains('is-open'); }
    /* D6-15 (refuter G-14): the select is the keyboard's element, so it carries the popup's state; the rows are one tab stop
       (roving: the current row), the arrow keys move within */
    if (!panel.id) panel.id = 'SvntySortList';
    select.setAttribute('aria-haspopup', 'listbox');
    select.setAttribute('aria-controls', panel.id);
    select.setAttribute('aria-expanded', 'false');
    sform.removeAttribute('aria-expanded');
    function rove(row) {
      Array.prototype.forEach.call(sheet.querySelectorAll('.svnty-ss__row'), function (r) { r.tabIndex = r === row ? 0 : -1; });
    }

    /* 8 px under the chip, right-aligned to it, never past the gutter (the fixed box is viewport-placed).
       D6-15 (refuter G-03): the menu closes on a page scroll, so every row must be reachable where it opens: when the rows
       do not fit below the chip it opens UPWARD (8 px above the chip, anchored by its bottom, the rows unrolling from the
       chip), and when neither side holds them it takes the roomier side, caps its height to the room and scrolls inside */
    function place() {
      var r = sform.getBoundingClientRect();
      var gutter = parseFloat(getComputedStyle(root).getPropertyValue('--svnty-gutter')) || 16;
      /* right-aligned to the chip; on a narrow phone the list narrows so its left edge never passes the gutter */
      var w = Math.min(260, Math.max(200, Math.round(r.right - gutter)));   /* the list ends on the chip; on the smallest phones it keeps 200 px for its words and passes the chip instead */
      sheet.style.width = w + 'px';
      sheet.style.left = Math.max(gutter, Math.round(r.right - w)) + 'px';
      sheet.style.right = 'auto';
      panel.style.maxHeight = '';
      var h = panel.scrollHeight + 2;                                   /* the rows + padding + the hairline, whatever the rise's state */
      var vh = window.innerHeight;
      var slab = document.querySelector('.svnty-headstack');
      var ceil = Math.max(gutter, slab ? Math.round(slab.getBoundingClientRect().bottom) + 8 : gutter);   /* never under the header */
      var below = vh - gutter - Math.round(r.bottom + 8), above = Math.round(r.top - 8) - ceil;
      var up = h > below && (h <= above || above > below);
      if (up) {
        sheet.setAttribute('data-up', '');
        sheet.style.top = 'auto';
        sheet.style.bottom = Math.round(vh - (r.top - 8)) + 'px';
      } else {
        sheet.removeAttribute('data-up');
        sheet.style.bottom = 'auto';
        sheet.style.top = Math.round(r.bottom + 8) + 'px';
      }
      var room = up ? above : below;
      if (h > room) panel.style.maxHeight = Math.max(88, room) + 'px';
    }
    function open() {
      lastFocus = document.activeElement;
      place();
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
      select.setAttribute('aria-expanded', 'true');
      var cur = sheet.querySelector('[aria-selected="true"]') || sheet.querySelector('.svnty-ss__row');
      if (cur) { rove(cur); focusQuiet(cur); if (panel.scrollHeight > panel.clientHeight) cur.scrollIntoView({ block: 'nearest' }); }
      document.addEventListener('keydown', onKey);
      document.addEventListener('pointerdown', onPress, true);
      document.addEventListener('pointerup', onRelease, true);
      document.addEventListener('pointercancel', onRelease, true);
      document.addEventListener('click', onOutside, true);
    }
    function close() {
      if (!isOpenMenu()) return;
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
      select.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('pointerdown', onPress, true);
      document.removeEventListener('pointerup', onRelease, true);
      document.removeEventListener('pointercancel', onRelease, true);
      document.removeEventListener('click', onOutside, true);
      pressOut = false; clearTimeout(pressTimer);
      /* focus returns to the chip: its select (the keyboard's element) unless the chip already held focus (F-21).
         D8-14 THE iOS PICKER GHOST (2026-09-26, image 24): a focus() on the <select> inside the tap's activation opens
         the native wheel on iOS right after our menu closes, so on a coarse pointer the chip's box (tabindex -1) takes the
         focus back and the select only ever takes it from the keyboard */
      focusQuiet(lastFocus && sform.contains(lastFocus) ? lastFocus : (COARSE ? sform : select));
    }
    window.addEventListener('resize', function () { if (isOpenMenu()) place(); }, { passive: true });
    /* the PAGE's scroll closes it (a window listener, not capture: the panel's own scroll, when capped, never reaches it,
       and the panel contains its overscroll so a flick at its end never scrolls the page) */
    window.addEventListener('scroll', function (e) { if (isOpenMenu() && !(e.target && e.target.nodeType === 1 && panel.contains(e.target))) close(); }, { passive: true });
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        var rows = Array.prototype.slice.call(sheet.querySelectorAll('.svnty-ss__row'));
        var i = rows.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        var to = rows[(i + (e.key === 'ArrowDown' ? 1 : rows.length - 1)) % rows.length];
        rove(to);
        to.focus();
      }
    }
    /* P17-24 THE OUTSIDE PRESS (lane 1's CL28 finding, reproduced at 320 and 1280 in Chromium and WebKit with a mouse held 120 ms):
       the press moved the focus out of the rows, the focusout below closed the menu a task later and took this capture listener
       with it, so the click that followed opened the card under the pointer. A press outside is now only remembered (memory,
       no DOM write: THE iOS TAP LAW), the focusout waits for its click, and the click closes the menu and is swallowed; a press
       that never becomes a click (a drag that did not scroll) closes it 600 ms after the release */
    var pressOut = false, pressTimer = 0;
    function onPress(e) {
      pressOut = !(panel.contains(e.target) || sform.contains(e.target));
      clearTimeout(pressTimer);
    }
    function onRelease() {
      if (!pressOut) return;
      clearTimeout(pressTimer);
      pressTimer = setTimeout(function () { if (pressOut && isOpenMenu()) close(); pressOut = false; }, 600);
    }
    function onOutside(e) {
      pressOut = false; clearTimeout(pressTimer);
      if (panel.contains(e.target) || sform.contains(e.target)) return;
      e.preventDefault();                                          /* the closing tap never reaches the page (F-23) */
      e.stopPropagation();
      close();
    }
    function mark(row) {
      Array.prototype.forEach.call(sheet.querySelectorAll('.svnty-ss__row'), function (r) { r.setAttribute('aria-selected', r === row ? 'true' : 'false'); });
      rove(row);
      if (value) value.textContent = row.getAttribute('data-svnty-sort-label') || '';
    }
    function pick(row) {
      var v = row.getAttribute('data-svnty-sort-value');
      mark(row);
      if (select.value !== v) {
        select.value = v;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sortCount();
      close();
    }

    /* the chip opens the face; the native select stays for the keyboard and VoiceOver (focusable, off the pointer) */
    sform.addEventListener('click', function (e) {
      if (e.target === select) return;
      e.preventDefault();
      if (isOpenMenu()) close(); else open();
    });
    select.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });
    select.addEventListener('change', function () {
      var row = sheet.querySelector('[data-svnty-sort-value="' + select.value + '"]');
      if (row && row.getAttribute('aria-selected') !== 'true') mark(row);
      sortCount();
    });
    /* the chip follows a URL it did not write: back and forward (facets.js re-renders the grid from the history's URL but
       never the chip). D6-15 (refuter G-02): and a link that renders a page (CLEAR ALL, the applied chips) never drops the
       sort: at the click, before facets.js reads the link, its URL takes the chip's sort (the foot's CLEAR ALL is printed
       once at load and never re-rendered, so its server-side sort can be stale); the default sort stays off the URL */
    function syncFrom(search) {
      var v = new URLSearchParams(search || '').get('sort_by') || def;
      if (v && select.value !== v && select.querySelector('option[value="' + v + '"]')) {
        select.value = v;
        var row = sheet.querySelector('[data-svnty-sort-value="' + v + '"]');
        if (row) mark(row);
      }
      sortCount();
    }
    window.addEventListener('popstate', function () { syncFrom(window.location.search); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('facet-remove a[href]');
      if (!a) return;
      try {
        var u = new URL(a.getAttribute('href') || '', window.location.href);
        if (select.value && select.value !== def) u.searchParams.set('sort_by', select.value); else u.searchParams.delete('sort_by');
        a.setAttribute('href', u.pathname + u.search);
      } catch (err) { /* a malformed link renders as it is */ }
    }, true);
    sortCount();
    rove(sheet.querySelector('[aria-selected="true"]') || sheet.querySelector('.svnty-ss__row'));
    sheet.addEventListener('click', function (e) {
      var row = e.target.closest('.svnty-ss__row');
      if (row) pick(row);
    });
    /* a popover, not a modal: focus leaving it closes it */
    sheet.addEventListener('focusout', function () {
      setTimeout(function () { if (isOpenMenu() && !pressOut && !panel.contains(document.activeElement) && !sform.contains(document.activeElement)) close(); }, 0);
    });
  }

  /* S-22 (lane SHEET_S, 2026-09-26): THE KEYBOARD'S MARK. A Tab press puts html[data-svnty-kbd] on, any press of a pointer or
     a finger takes it off; the bar's FILTER and SORT show their focus (THE LINE DOOR's rule under the word, svnty-filter.css)
     only while it is on AND the control matches :focus-visible, so a pointer or a touch never shows it (D8-13 stands) */
  function modality() {
    /* GUARDS_Part8 (CL39): WebKit matches :focus-visible on the <select> after a mouse pick, so the mark is the Tab key's alone */
    document.addEventListener('keydown', function (e) { if (e.key === 'Tab') root.setAttribute('data-svnty-kbd', ''); }, true);
    ['pointerdown', 'touchstart'].forEach(function (t) { document.addEventListener(t, function () { root.removeAttribute('data-svnty-kbd'); }, { capture: true, passive: true }); });
  }

  function boot() {
    modality();
    hoist();
    seedGroups();
    colourTaps();
    colourGroup();
    valueLines();
    mirrorCount();
    filterCount();
    markPreset();
    panelLock();
    sortMenu();
    var wrap = document.getElementById('FacetsWrapperMobile');
    var after = function () { requestAnimationFrame(function () { order(); seedGroups(); colourGroup(); if (scope.url) loadScope(); valueLines(); markPreset(); mirrorCount(); }); };
    if (wrap && typeof MutationObserver === 'function') new MutationObserver(after).observe(wrap, { childList: true, subtree: true });
    if (form) form.addEventListener('input', function () { requestAnimationFrame(valueLines); });
    var container = document.getElementById('ProductGridContainer');
    if (container && typeof MutationObserver === 'function') new MutationObserver(function () { requestAnimationFrame(mirrorCount); }).observe(container, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
